/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:24:18 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
  CONDITION_OPERATORS,
  FormConfiguration,
  FormField,
  ICondition,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";
import { schemaBuilder, Many2OneIntPKBaseSchema } from "lib/validation";
import { NextActivation } from "./ActivationBranch";

export interface ActivationCondition extends ProcessTemplateArtifact, WritableModel<false>, ICondition {
  activation: NextActivation["id"];
  condition_form: FormConfiguration["id"];
  condition_field: FormField["id"];
  readonly condition_field_label?: FormField["label"];
  readonly condition_value_rendered?: any;
}

type WriteOnlyActivationCondition = Omit<
  ActivationCondition,
  "id" | "condition_field_label" | "condition_value_rendered"
>;

export const ActivationConditionValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyActivationCondition> =
  ProcessTemplateArtifactValidationSchema.shape({
    activation: Many2OneIntPKBaseSchema().required("An activation is required when adding a condition."),
    condition_form: Many2OneIntPKBaseSchema().required("A form is required when adding a condition."),
    condition_field: Many2OneIntPKBaseSchema().required("A form field is required when adding a condition."),
    condition_operator: schemaBuilder
      .mixed()
      .oneOf(Object.keys(CONDITION_OPERATORS))
      .required("Condition Operator is required"),
    condition_value: schemaBuilder.string().optional().nullable(),
  });
